import {AuthError} from '../types';

export default function isAuthError(obj: unknown): obj is AuthError {
    return (
        typeof obj === 'object' &&
        obj !== null &&
        typeof (obj as AuthError).error === 'string' &&
        typeof (obj as AuthError).error_description === 'string'
    );
}
